// Columns the job LIST pages load (jobs has ~140 columns; select('*') made each list ~3.5× slower — measured live
// 6 Oct 2026: 695 ms → 194 ms). Each list is the set of job columns its page and every helper it uses read
// (found by scanning the code, generously). The job page itself still loads the full row.
//
// ⚠ When a list page (or a helper it uses: workflow.js, coi.js, service.js, expiry.js, pipeline.js,
//   dashboardAttention.js, auditorAssignment.js) starts reading ANOTHER job column, add it here — otherwise it is
//   simply undefined on that page.

// Jobs page (pages/Jobs.js) — incl. the SAC audit list.
export const JOBS_LIST_COLUMNS = [
  'id', 'created_at', 'client_id', 'audit_type', 'scope', 'status', 'audit_date', 'mandays', 'auditor_id', 'auditor_name',
  'form_data', 'notes', 'auditor2_id', 'auditor2_name', 'audit_site_address', 'business_nature', 'project_name',
  'report_submitted', 'auditor_closed', 'workflow_state', 'office_review_at', 'wshc_new_expiry', 'report_ack_sent_at',
  'report_ack_version', 'assigned_to_name', 'application_type', 'combined_group_id', 'is_combined_primary',
  'report_acknowledged_at', 'report_acknowledged_version', 'ia_cycle_id', 'ia_stage', 'ia_plan_token', 'ote_stage',
  // New WSHC client-portal process (lib/bizsafePortal.js)
  'wshc_flow', 'wshc_applicant_email', 'wshc_apply_email_sent_at', 'client_wshc_submitted_at', 'wshc_ended_at', 'wshc_outcome',
].join(',')

// Dashboard (pages/Dashboard.js → dashboardAttention.js, pipeline.js).
export const DASHBOARD_JOB_COLUMNS = [
  'id', 'created_at', 'client_id', 'audit_type', 'scope', 'status', 'audit_date', 'mandays', 'auditor_id', 'auditor_name',
  'quote_ref', 'signed_date', 'form_data', 'notes', 'auditor2_id', 'auditor2_name', 'business_nature', 'plan_sent_date',
  'client_ack_token', 'qm_clearance', 'report_submitted', 'report_submitted_by', 'ack_signature', 'plan_signature',
  'audit_plan_sent_at', 'workflow_state', 'office_review_at', 'returned_at', 'submitted_to_wshc_at', 'report_ack_sent_at',
  'report_ack_version', 'assigned_to_name', 'application_type', 'combined_group_id', 'is_combined_primary',
  'report_acknowledged_at', 'report_acknowledged_version', 'ia_stage', 'ia_plan_token', 'ote_stage',
  // New WSHC client-portal process (lib/bizsafePortal.js)
  'wshc_flow', 'wshc_applicant_email', 'wshc_apply_email_sent_at', 'client_wshc_submitted_at', 'wshc_ended_at', 'wshc_outcome',
].join(',')

// My Audits (pages/MyAudits.js → auditorAssignment.js).
export const MY_AUDITS_JOB_COLUMNS = [
  'id', 'audit_type', 'scope', 'status', 'audit_date', 'auditor_id', 'auditor_name', 'form_data', 'auditor2_id',
  'auditor2_name', 'auditor_coi_tokens', 'report_submitted', 'report_submitted_at', 'auditor_closed', 'workflow_state',
  'application_type', 'ia_stage', 'ia_plan_token', 'ia_report_sent_at', 'report_signatures', 'ote_stage',
].join(',')
